export default __webpack_public_path__ + "static/media/bell.03369785.svg";